module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av251-deb47ac835b59685048997d4b56ec248.jpg";